import moment from 'moment'

export function formatUnix (stamp, format = 'DD/MM/YYYY') {
		return moment.unix(stamp).format(format)
}
  
export {moment}